



































import { Component } from 'vue-property-decorator';
import BaseLoad from '@/component/evaluate/base/base-load';
import '../css/card.less';
import ParamCard from '@/component/evaluate/card-params/param-card.vue';
import MessageBus from '@/Utils/message/message-bus';
@Component({
    components: {
        ParamCard,
    },
})
/**
 * @author guan
 * @description 通用模板，特殊界面以及特殊需求，请继承RenderTemplate
 */
//eslint-disable-next-line
export default class BaseComponent extends BaseLoad<any> {
    /**
     * 更新数据
     */
    updateData(data: { content: string; data: string }): void {
        this.cardMessage[this.paramsMapList[data.content].prop] = data.data;
        this.saveResults();
    }

    /**
     * 保存数据
     */
    saveResults(): void {
        this.saveData()
            .then(() => {
                MessageBus.Message('success', '保存成功');
            })
            .catch((e) => {
                throw e;
            });
    }
}
